/* =========================================================
   Affiche GOLF « La saison » — l'index, le sac, le swing.
   API : SNGolfSaison.render(data, opts) -> string SVG
     data : { mode, club, saison, joueur, date, titre, kicker,
              index : v1..v12 (valeurs d'index) + m1, m6, m12 (libellés d'axe)
              sac   : c1..c14 (« Nom du club|distance »)
              swing : vitesse, unite, carry, angle, effet }
       mode : 'index' → la courbe de l'index (axe INVERSÉ : descendre = progresser)
              'sac'   → les clubs et leurs distances, en barres
              'swing' → le plan de swing décomposé en arcs
     opts : { palette }
   L'écart d'index et l'échelle du graphique sont CALCULÉS.
   Auto-suffisant → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    craie: { label:'Craie', bg:'#F7F4ED', ink:'#0B2D5B', muted:'#8B94A3', accent:'#FF6B2C', line:'#E3DDD0', card:'#FFFFFF', deep:'#DFE7DF' },
    sable: { label:'Sable', bg:'#EDE3D2', ink:'#2C3A2E', muted:'#8A8676', accent:'#C4622D', line:'#DDD0B9', card:'#F7F1E6', deep:'#DCCFB6' },
    green: { label:'Gazon', bg:'#0E3B2E', ink:'#F4F1E8', muted:'#8FB3A5', accent:'#FF6B2C', line:'#1C5544', card:'#134536', deep:'#0A2E23' },
    nuit:  { label:'Nuit',  bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', deep:'#082444' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fmt = n => (Math.round(n * 10) / 10).toFixed(1).replace('.', ',');
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };
  function ball(cx, cy, r, p, fill) {
    let d = '';
    for (let ring = 1; ring <= 3; ring++) {
      const rr = r * (0.30 + ring * 0.21), n = 6 + ring * 3;
      for (let i = 0; i < n; i++) {
        const a = (i / n) * Math.PI * 2 + ring * 0.4;
        const x = cx + Math.cos(a) * rr, y = cy + Math.sin(a) * rr;
        if (Math.sqrt((x-cx)*(x-cx) + (y-cy)*(y-cy)) > r - r*0.13) continue;
        d += `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${(r*0.062).toFixed(1)}" fill="${p.muted}" opacity="0.38"/>`;
      }
    }
    return `<circle cx="${cx}" cy="${cy}" r="${r}" fill="${fill||p.ink}"/>${d}`;
  }
  function stats(p, items, y, x0) {
    x0 = x0 || 54;
    const it = items.filter(x => String(x[0] || '').trim());
    if (!it.length) return '';
    const w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 38, 0.56, 0, 18), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const mode = String(data.mode || 'index').toLowerCase();
    const cx = PW / 2;

    const DEF = { index:'MON INDEX', sac:'MON SAC', swing:'MON SWING' };
    const titre = up(data.titre) || DEF[mode] || 'MA SAISON';
    const ts = fit(titre, 700, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || up(data.saison) || 'MA SAISON';
    const sous = up(data.club);

    let corps = '', barre = '';

    if (mode === 'index') {
      const pts = [];
      for (let i = 1; i <= 12; i++) { const v = num(data['v' + i]); if (v != null) pts.push(v); }
      if (pts.length >= 2) {
        const mn = Math.min.apply(null, pts), mx = Math.max.apply(null, pts);
        const marge = Math.max((mx - mn) * 0.22, 0.6);
        const lo = mn - marge, hi = mx + marge;
        const X0 = 108, X1 = PW - MX, Y0 = 780, Y1 = 430;
        const xx = i => X0 + (i / (pts.length - 1)) * (X1 - X0);
        /* Axe INVERSÉ : un index qui BAISSE doit MONTER sur le graphique. */
        const yy = v => Y0 - ((hi - v) / (hi - lo)) * (Y0 - Y1);
        const pas = (mx - mn) / 3 || 1;
        const mag = Math.pow(10, Math.floor(Math.log(pas) / Math.LN10));
        const step = [1, 2, 2.5, 5, 10].map(m => m * mag).find(s => s >= pas) || mag * 10;
        for (let g = Math.ceil(mn / step) * step; g <= mx + 0.001; g += step) {
          corps += `<line x1="${X0-12}" y1="${yy(g).toFixed(1)}" x2="${X1}" y2="${yy(g).toFixed(1)}" stroke="${p.line}" stroke-width="1.4"/>`
            + T(X0-24, yy(g)+5, 15, p.muted, fmt(g).replace(',0',''), { w:600, a:'end' });
        }
        const co = pts.map((v, i) => `${xx(i).toFixed(1)},${yy(v).toFixed(1)}`);
        corps += `<path d="M ${co[0]} L ${co.slice(1).join(' L ')} L ${X1},${Y0} L ${X0},${Y0} Z" fill="${p.accent}" opacity="0.10"/>`
          + `<path d="M ${co[0]} L ${co.slice(1).join(' L ')}" fill="none" stroke="${p.accent}" stroke-width="5" stroke-linejoin="round" stroke-linecap="round"/>`;
        pts.forEach((v, i) => { corps += `<circle cx="${xx(i).toFixed(1)}" cy="${yy(v).toFixed(1)}" r="5.5" fill="${p.ink}"/>`; });
        const li = pts.length - 1;
        corps += `<circle cx="${xx(li).toFixed(1)}" cy="${yy(pts[li]).toFixed(1)}" r="13" fill="${p.accent}"/><circle cx="${xx(li).toFixed(1)}" cy="${yy(pts[li]).toFixed(1)}" r="5" fill="${p.bg}"/>`;
        [[0, data.m1], [Math.floor(li/2), data.m6], [li, data.m12]].forEach(([i, lab], k) => {
          if (!lab) return;
          corps += T(k === 0 ? X0 : k === 2 ? X1 : xx(i), Y0 + 38, 15, p.muted, esc(up(lab)), { w:600, ls:2, a: k === 0 ? 'start' : k === 2 ? 'end' : 'middle' });
        });
        const delta = pts[li] - pts[0];
        corps += `<text x="${MX}" y="330" font-family="Oswald" font-weight="700" fill="${p.accent}" text-anchor="start"><tspan font-size="86">${delta <= 0 ? '' : '+'}${fmt(delta)}</tspan></text>`
          + T(MX, 362, 15, p.muted, 'SUR LA SAISON', { w:600, ls:3, a:'start' })
          + `<text x="${PW-MX}" y="330" font-family="Oswald" font-weight="700" fill="${p.ink}" text-anchor="end"><tspan font-size="86">${fmt(pts[li])}</tspan></text>`
          + T(PW-MX, 362, 15, p.muted, 'INDEX FINAL', { w:600, ls:3, a:'end' });
        barre = stats(p, [[fmt(pts[0]), 'Départ'], [data.parcours, 'Parcours'], [data.competitions, 'Compétitions'], [data.birdies, 'Birdies']], 900);
      } else {
        corps = T(cx, 600, 22, p.muted, 'SAISISSEZ AU MOINS DEUX RELEVÉS D INDEX', { w:600, ls:3 });
      }
    } else if (mode === 'sac') {
      const clubs = [];
      for (let i = 1; i <= 14; i++) {
        const raw = String(data['c' + i] || '').trim(); if (!raw) continue;
        const [nom, dist] = raw.split('|').map(s => (s || '').trim());
        const d = num(dist); if (!nom || d == null) continue;
        clubs.push([nom, d]);
      }
      if (clubs.length) {
        const maxD = Math.max.apply(null, clubs.map(c => c[1])) * 1.04;
        const x0 = MX + 136, larg = PW - MX - x0;
        const pas = Math.min(44, Math.max(26, Math.floor(560 / clubs.length)));
        clubs.forEach((c, i) => {
          const y = 306 + i * pas;
          corps += T(MX, y + 5, 15, p.ink, esc(up(c[0])), { w:700, ls:1, a:'start' })
            + `<rect x="${x0}" y="${y-9}" width="${larg}" height="18" rx="9" fill="${p.deep}"/>`;
          const w = (c[1] / maxD) * larg;
          corps += `<rect x="${x0}" y="${y-9}" width="${w.toFixed(1)}" height="18" rx="9" fill="${i === 0 ? p.accent : p.ink}"/>`
            + T(x0 + w - 10, y + 5, 13, p.bg, c[1] + ' m', { w:700, a:'end' });
        });
        barre = stats(p, [[clubs[0][1] + ' m', clubs[0][0]], [String(clubs.length), 'Clubs'], [data.indexJoueur, 'Index']], 946);
      }
    } else { /* swing */
      const scx = 400, scy = 640, R = 250;
      corps = `<path d="M ${scx-R} ${scy} A ${R} ${R} 0 0 1 ${scx+R} ${scy}" fill="none" stroke="${p.line}" stroke-width="1.6" stroke-dasharray="6 10"/>`;
      for (let i = 0; i <= 8; i++) {
        const a = Math.PI * (0.82 + i * 0.17);
        const x = scx + Math.cos(a) * R, y = scy + Math.sin(a) * R;
        const op = (0.18 + i * 0.10).toFixed(2);
        corps += `<line x1="${scx}" y1="${scy}" x2="${x.toFixed(1)}" y2="${y.toFixed(1)}" stroke="${i===8?p.accent:p.ink}" stroke-width="${i===8?6:3}" stroke-linecap="round" opacity="${i===8?1:op}"/>`
          + `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${i===8?9:5}" fill="${i===8?p.accent:p.ink}" opacity="${i===8?1:op}"/>`;
      }
      corps += `<circle cx="${scx}" cy="${scy}" r="13" fill="${p.ink}"/>` + ball(scx + 152, scy + 6, 21, p, p.ink)
        + `<text x="${cx}" y="348" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.ink}"><tspan font-size="116">${esc(up(data.vitesse) || '—')}</tspan><tspan font-size="34" fill="${p.accent}" dx="8">${esc(up(data.unite) || 'KM/H')}</tspan></text>`
        + T(cx, 396, 15, p.muted, 'VITESSE DE TÊTE DE CLUB', { w:600, ls:5 });
      barre = stats(p, [[data.carry, 'Carry'], [data.angle, 'Angle'], [data.effet, 'Effet']], 946);
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, 17, p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${barre}
${data.joueur ? T(cx, 1000, 19, p.ink, esc(up(data.joueur)), { f:'Oswald', w:700, ls:2 }) : ''}
${data.date ? T(cx, 1030, 14, p.muted, esc(up(data.date)), { w:600, ls:4 }) : ''}
</svg>`;
  }

  window.SNGolfSaison = { render, PALETTES };
})();
